"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = exports.Hider = exports.HiderPanel = void 0;
const react_1 = __importDefault(require("react"));
const Icons = __importStar(require("./icons/index"));
const classnames_1 = __importDefault(require("classnames"));
const cypress_constants_1 = require("../cypress_constants");
const typestyle_1 = require("typestyle");
const Colors_1 = require("../Colors");
const vars_1 = require("../vars");
exports.HiderPanel = typestyle_1.style({
    width: vars_1.menuWidth,
    background: Colors_1.Colors.main[10],
    color: Colors_1.Colors.grey[7],
    fontSize: 12,
    padding: 3,
    zIndex: 3,
});
exports.Hider = typestyle_1.style({
    width: 42,
    height: 42,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
    cursor: 'pointer',
    $nest: {
        '&:hover': {
            background: Colors_1.Colors.grey[10],
        },
        '&.active': {
            color: Colors_1.Colors.pink[0],
        },
    },
});
exports.Menu = ({ setActivePane, activePane }) => {
    return (react_1.default.createElement("div", { className: exports.HiderPanel },
        react_1.default.createElement("div", { "data-cy": cypress_constants_1.cypressGet(cypress_constants_1.GraphQLEditorCypress, 'sidebar', 'menu', 'children', 'diagram', 'name'), className: classnames_1.default(exports.Hider, {
                active: activePane === 'diagram',
            }), onClick: () => setActivePane('diagram'), title: "Diagram View" },
            react_1.default.createElement(Icons.Eye, { size: 18 })),
        react_1.default.createElement("div", { "data-cy": cypress_constants_1.cypressGet(cypress_constants_1.GraphQLEditorCypress, 'sidebar', 'menu', 'children', 'codeDiagram', 'name'), className: classnames_1.default(exports.Hider, {
                active: activePane === 'code-diagram',
            }), onClick: () => setActivePane('code-diagram'), title: "Code and Diagram View" },
            react_1.default.createElement(Icons.Code, { size: 18 })),
        react_1.default.createElement("div", { "data-cy": cypress_constants_1.cypressGet(cypress_constants_1.GraphQLEditorCypress, 'sidebar', 'menu', 'children', 'code', 'name'), className: classnames_1.default(exports.Hider, {
                active: activePane === 'code',
            }), onClick: () => setActivePane('code'), title: "Code View" },
            react_1.default.createElement(Icons.FullScreen, { size: 18 })),
        react_1.default.createElement("div", { "data-cy": cypress_constants_1.cypressGet(cypress_constants_1.GraphQLEditorCypress, 'sidebar', 'menu', 'children', 'hierarchy'), className: classnames_1.default(exports.Hider, {
                active: activePane === 'hierarchy',
            }), onClick: () => setActivePane('hierarchy'), title: "Hierarchy View" },
            react_1.default.createElement(Icons.Layers, { size: 18 }))));
};
